import Checkbox from "@material-ui/core/Checkbox";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import React from "react";
import styled from "styled-components";
import COLORS from "../../../../assets/colors";
import { AIGeneratorType } from "../../../../enums/AIGeneratorType";
import { SkillTabIndexType } from "../../../../enums/SkillTabIndexType";
import { SourceType } from "../../../../enums/SourceType";
import { UserType } from "../../../../enums/UserType";
import { FilterTableRow } from "../../../../helpers/FilterTableRow";
import text from "../../../../locale.en.json";
import AIGenerator from "../../../Common/AIGenerator";
import { PrimaryButton } from "../../../Common/Buttons/PrimaryButton";
import ConfirmationButton from "../../../Common/ConfirmationButton";
import CustomizedTables from "../../../Common/CustomizedTables";
import AutoSelectBox from "../../../Common/FormElements/AutoSelectBox";
import DotLoader from "../../../Common/Loader/DotLoader";
import ModalPopup from "../../../Common/ModalPopup";
import RowCount from "../../../Common/Others/RowCount";
import PaginationCustom from "../../../Common/PaginationCustom";
import TabCustom from "../../../Common/TabCustom";
import TabPanel from "../../../Common/TabPanel";
import { H5,  } from "../../../Common/Typography";
import { getSkillContentTableColumns, Skill_Persona_Table } from "../../ArchitectSkills/SkillContent/SkillContentTable";
import SkillAssessment from "../SkillAssessment";
import SkillContentDetail from "../SkillContentDetail";
import useSkillsManageTable from "./useSkillsManageTable";
import RelevancyButton from "./RelavancyButton";
import { ContentRelevancyType } from "../../../../enums/ContentRelevancyType";
import ContentStatusMessage from "./ContentStatusMessage";
import { isDisprzAtomicSkillSource, isGenAiDisprzAtomicSkillSource } from "../../../../helpers/CommonHelper";
// import ToolBar from "../../../Common/ToolBar";
import { ProficiancyStatus } from "../../../../enums/ProficiencyStatus";

export default ({ ...props }) => {
  const { id, detailData, skillDetail, levels , schemeIDData} = props;
  const {
    tabList,
    handleTab,
    currentTab,
    skillSourceId,
    proficiencyTableColumn,
    proficiencyArray,
    handleColChange,
    currentProRow,
    handleProSelect,
    handleProficiencyEdit,
    handleProficiencySave,
    handleProficiencyDelete,
    updateReset,
    profiTableHeight,
    handleAiGenerator,
    handleAddPro,
    User_Type,
    showIrrelevantCourses,
    handleShowIrrelevantCoursesChange,
    getRelevancyButtonProps,
    confirmPopup,
    isRelevant,
    handleUpdateContentRelevancy,
    setConfirmPopup,
    contentLoading,
    skillContentItems,
    skillContentItemsCopy,
    currentContentItemRow,
    handleChangeRelevancy,
    handleCheckBox,
    handleCheckAll,
    handleContentItemEdit,
    handleContentItemSave,
    handlePagination,
    rowCount,
    changeRowCount,
    contentStates,
    skillRolesCopy,
    roleTableColumn,
    skillRoles,
    currenRoleRow,
    handleRoleSelect,
    handleRoleEdit,
    handleRoleSave,
    handleRoleDelete,
    roletableHeight,
    setSkillRoles,
    skillPersonasCopy,
    skillPersonas,
    setSkillPersonas,
    skillAssessmentList,
    skillAssessmentListCopy,
    levelMenuRoles,
    getAssessmentList,
    assessmentGenerated,
    showDescriptionLevelPopUp,
    handleAiGeneratorNoClick,
    getStoreKey,
    updateLevelsDescriptions,
    contentDetailModal,
    warningPopUp,
    handleAddRole,
    setSkillAssessmentList,
    handleAiGeneratorYesClick,
    handleContentTableCancelClick,
    handleContentTableResetRow,
    handleContentTableSort,
    handleContentTableFilterValues,
    handleRoleTableSort,
    handleRoleTableResetList,
    handleRoleTableResetRow,
    handlePersonaTableSort,
    handlePersonaTableResetList,
    handleCloseContentDetailModal,
    handleCloseWarningPopup,
    // createSkillProficienciesWithSchemeBulkAsync,
    // updateSkillProficienciesWithSchemeBulkAsync,
    setCurrentProRow,
    // setIsSavePLDisabled,
    // isSavePLDisabled,
    generateProficiencyArray,
    // modifyProficiency,
    getServiceUrl,
    // isProficencyUpdate,
    // proficiencyList
  } = useSkillsManageTable({ id, detailData, levels ,schemeIDData});
          
return (
    <>
      {/* skill related details */}
      <SkillTableBlock>
        <TabCustom tabTitle={tabList} getTabNumber={handleTab} currentTab={currentTab}>

          {/* skill proficiencies  */}
          <TabPanel value={currentTab} index={SkillTabIndexType.PROFICIENCY} style={{ padding: 0 }} className="top-table">
            {!!skillSourceId &&  skillSourceId === SourceType.DISPRZ_ATOMIC_SKILLS && (
                <div className="choose-proficiency-level">
                  <H5>{text.proficiencies.howManyProficiencyToConfigure}</H5>
                  <div className="select-box">
                    <AutoSelectBox stateValue={5} disabled={true} />
                  </div>
                </div>
              )}
            {(!isGenAiDisprzAtomicSkillSource(skillSourceId) || (isGenAiDisprzAtomicSkillSource(skillSourceId) && detailData?.proficiencyStatus === ProficiancyStatus.COMPLETED)) &&
             <CustomizedTables
              columns={proficiencyTableColumn}
              rowList={proficiencyArray}
              columnChange={handleColChange}
              currentRow={currentProRow}
              handleSelect={handleProSelect}
              editClick={handleProficiencyEdit}
              saveClick={handleProficiencySave}
              deleteClick={handleProficiencyDelete}
              cancelClick={(e)=>{
                e.preventDefault();
                setCurrentProRow(null);
                generateProficiencyArray();
              }}
              stickyHeader={proficiencyArray?.length > 10 && currentTab === 0}
              tableHeight={proficiencyArray?.length > 10 && currentTab === 0 ? profiTableHeight : "auto" } 
              className="profi-table"
              innerTabel={true}
              deleteConfirm={true}
              deleteConfirmText={text.proficiencies.confirmDeleteProficiency}
              handleAiGenerator={handleAiGenerator}
              saveAndCancel={isGenAiDisprzAtomicSkillSource(skillSourceId) ? true :  false}
            />}
            {isGenAiDisprzAtomicSkillSource(skillSourceId) &&  detailData?.proficiencyStatus === ProficiancyStatus.NOT_STARTED ? <div className="proficiency-status">{text.proficiencies.proficienciesAreYetToBeCreated}</div> : null}
            {isGenAiDisprzAtomicSkillSource(skillSourceId) &&  detailData?.proficiencyStatus === ProficiancyStatus.IN_PROGRESS ? <div className="proficiency-status">{text.proficiencies.proficienciesAreBeingCreated}</div> : null}
            {isGenAiDisprzAtomicSkillSource(skillSourceId) &&  detailData?.proficiencyStatus === ProficiancyStatus.ERROR ? <div className="proficiency-status">{text.proficiencies.errorInProficiencyCreation}</div> : null}
            <div className={`btn-block`}>
              {/* COMMENTING THIS AS WE WILL NOT ALLOW THE USER TO SAVE, EDIT, ADD THE PL FOR THE GEN_AI_SOURCE MANUALLY 
                {isGenAiDisprzAtomicSkillSource(skillSourceId) ? (
                <ToolBar title={isSavePLDisabled ? text.proficiencies.savePlDataTooltip : ""} placement="right" arrow darkMode>
                  <span>
                    <PrimaryButton
                      onClick={(e) => {
                        e.preventDefault(); // Prevent default button behavior
                        if (isProficencyUpdate) {
                          updateSkillProficienciesWithSchemeBulkAsync(proficiencyList);
                        } else {
                          createSkillProficienciesWithSchemeBulkAsync(levelDataMap, schemeIDData);
                          setIsProficencyUpdate(true);
                          setTimeout(() => {
                            modifyProficiency(); // Call your save function
                          }, 1000);
                        }
                        setIsSavePLDisabled(true);
                      }}
                      disabled={isSavePLDisabled}
                    >
                      {text.proficiencies.savePlData}
                    </PrimaryButton>
                  </span>
                </ToolBar>  
              ) : (
                <PrimaryButton onClick={handleAddPro}>
                  {text.proficiencies.addLevel}
                </PrimaryButton>
              )} */}
              {!isGenAiDisprzAtomicSkillSource(skillSourceId) && (
                <PrimaryButton onClick={handleAddPro}>
                  {text.proficiencies.addLevel}
                </PrimaryButton>
              )}
            </div>
          </TabPanel>
          
          {/* if user is not SME, show other skill related details */}
          {User_Type !== UserType.SME && (
            <>
              {/* contents mapped to the skills */}
              <TabPanel value={currentTab} index={SkillTabIndexType.CONTENT}>
                <div className={"control-header"}>
                  <FormControlLabel
                    control={
                      <Checkbox
                        checked={showIrrelevantCourses}
                        onChange={handleShowIrrelevantCoursesChange}
                        name="showIrrelevantCourses"
                        color="primary"
                      />
                    }
                    label={text.content.showContentMarkedAsIrrelevant}
                  />
                  <div className="relevancy-btn">
                    <RelevancyButton type={ContentRelevancyType.RELEVANT} getRelevancyButtonProps={getRelevancyButtonProps} />
                    {!showIrrelevantCourses && <RelevancyButton type={ContentRelevancyType.IRRELEVANT} getRelevancyButtonProps={getRelevancyButtonProps} />}
                  </div>
                </div>
                <ModalPopup
                  open={confirmPopup}
                  maxWidth="sm"
                  title={text.content.markSelectedContent.replace("{{relevancy}}", isRelevant ? text.content.relevant : text.content.irrelevant)}
                  center={true}
                >
                  <ConfirmationButton yesClick={handleUpdateContentRelevancy} noClick={() => setConfirmPopup(false)} />
                </ModalPopup>
                <div className={"content-table"}>
                  {contentLoading ? <Backdrop><DotLoader/></Backdrop> : ("")}
                  <CustomizedTables
                    columns={getSkillContentTableColumns(isGenAiDisprzAtomicSkillSource(skillSourceId))}
                    rowList={skillContentItems?.contentDetailList}
                    rowListCopy={skillContentItemsCopy?.contentDetailList}
                    innerTabel={true}
                    currentRow={currentContentItemRow}
                    handleSelect={handleChangeRelevancy}
                    handleCheckBox={handleCheckBox}
                    handleCheckAll={handleCheckAll}
                    editClick={handleContentItemEdit}
                    saveClick={handleContentItemSave}
                    cancelClick={handleContentTableCancelClick}
                    resetRow={handleContentTableResetRow}
                    saveAndCancel={true}
                    sortAndFilterAPILevel={{ sort: true, filter: true }}
                    handleSortTable={handleContentTableSort}
                    filterList={skillContentItems?.filters || []}
                    getFilterValues={handleContentTableFilterValues}
                  />
                </div>
                {skillContentItems?.total > 10 && !contentLoading ? (
                  <PaginationCustom pageTotal={skillContentItems?.total} handlePagination={handlePagination} countRows={rowCount} changeRowCount={changeRowCount} />
                ) : null}
                {
                  (!skillContentItemsCopy?.contentDetailList?.length) ?
                  <ContentStatusMessage contentStates={contentStates} /> : null
                }
              </TabPanel>

              {/* roles mapped to the skills */}
              <TabPanel value={currentTab} index={SkillTabIndexType.ROLES} key={`roles-tab-${levels}`}>
                <RowCount text={text.role.rolesMapped} count={isGenAiDisprzAtomicSkillSource(skillSourceId) ? skillRolesCopy?.filter((s) => s.proficiencySchemeLevelCount === levels)?.length : skillRolesCopy?.length} />
                <CustomizedTables
                  columns={roleTableColumn}
                  rowList={skillRoles}
                  rowListCopy={skillRolesCopy} 
                  currentRow={currenRoleRow}
                  handleSelect={handleRoleSelect}
                  editClick={handleRoleEdit}
                  saveClick={handleRoleSave}
                  deleteClick={handleRoleDelete}
                  cancelClick={updateReset}
                  stickyHeader={skillRoles?.length > 10}
                  tableHeight={ skillRoles?.length > 10 && currentTab === 2 ? roletableHeight : "auto" }
                  innerTabel={true}
                  deleteConfirm={true}
                  deleteConfirmText={text.role.confirmDeleteRole}
                  sortList={handleRoleTableSort}
                  filterChange={(item, reason, colKey, list) => FilterTableRow(item, reason, colKey, list, setSkillRoles)}
                  resetList={handleRoleTableResetList}
                  resetRow={handleRoleTableResetRow}
                />
                {/* Commneting the below functionality as part of the non 5 PL
                <div className="btn-block">
                  <PrimaryButton onClick={handleAddRole}>
                    {text.role.addRole}
                  </PrimaryButton>
                </div> */}
                {!isGenAiDisprzAtomicSkillSource(skillSourceId) && (
                <div className="btn-block">
                  <PrimaryButton onClick={handleAddRole}>
                    {text.role.addRole}
                  </PrimaryButton>
                </div> 
                )}
              </TabPanel>

              {/* personas mapped to the skills*/}
              <TabPanel value={currentTab} index={SkillTabIndexType.PERSONA} key={`persona-tab-${levels}`}>
                <RowCount text={text.persona.personaMapped} count={isGenAiDisprzAtomicSkillSource(skillSourceId) ? skillPersonasCopy?.filter((p) => p.proficiencySchemeLevelCount === levels)?.length : skillPersonasCopy?.length} />
                <CustomizedTables
                  columns={Skill_Persona_Table}
                  rowList={skillPersonas}
                  innerTabel={true}
                  rowListCopy={skillPersonasCopy}
                  sortList={handlePersonaTableSort}
                  filterChange={(item, reason, colKey, list) => FilterTableRow(item, reason, colKey, list, setSkillPersonas)}
                  resetList={handlePersonaTableResetList}
                />
              </TabPanel>

              {/* skill assessments configurations */}
              <TabPanel value={currentTab} index={SkillTabIndexType.ASSESSMENT} key={`assess-tab-${levels}`}>
                {!!skillAssessmentList && (
                  <SkillAssessment
                    list={skillAssessmentList || []}
                    listCopy={skillAssessmentListCopy}
                    setList={setSkillAssessmentList}
                    levelMenu={levelMenuRoles || []}
                    skillId={id}
                    getAssessmentList={getAssessmentList}
                    proficiencyArray={proficiencyArray}
                    detailData={detailData}
                    assessmentGenerated={assessmentGenerated}
                    levels={isGenAiDisprzAtomicSkillSource(skillSourceId) ? levels : isDisprzAtomicSkillSource(skillSourceId) ? 5 : 0}
                  />
                )}
              </TabPanel>
            </>
          )}
        </TabCustom>
      </SkillTableBlock>

      {/* AI Generator for skill proficiencies & knowledge descriptions*/}
      <ModalPopup
        open={showDescriptionLevelPopUp.proficiencyDescriptionLevel || showDescriptionLevelPopUp.knowledgeDescriptionLevel}
        maxWidth="lg"
        title={showDescriptionLevelPopUp.proficiencyDescriptionLevel ? text.proficiencies.proficiencyDescription : text.proficiencies.knowledgeDescription}
        center={true}
      >
        <AIGenerator
          generatorType={AIGeneratorType.LEVEL}
          getServiceUrl={getServiceUrl}
          params={skillDetail}
          cancelText={text.common.close}
          confirmText={text.common.addToMainScreen}
          onCancel={handleAiGeneratorNoClick}
          onConfirm={handleAiGeneratorYesClick}
          placeholder=""
          knowledgeDescriptionLevel={showDescriptionLevelPopUp.knowledgeDescriptionLevel}
          levels={levels}
          aiStoreKey={getStoreKey()}
          updateLevelsDescriptions={updateLevelsDescriptions}
          isGenAiDisprzAtomic={isGenAiDisprzAtomicSkillSource(skillSourceId)}
        />
      </ModalPopup>

      {/* Content detail modal */}
      <ModalPopup
        open={contentDetailModal}
        maxWidth="md"
        closePopup={handleCloseContentDetailModal}
        title={text.common.details}
      >
        <SkillContentDetail skillId={id} />
      </ModalPopup>

      {/* Modal to indicate the user to select maximum of 50 contents at a time */}
      <ModalPopup
        open={warningPopUp}
        maxWidth="sm"
        title={text.common.selectMax50}
        center={true}
        className="warning-modal"
      >
        <ConfirmBlock>
          <PrimaryButton onClick={handleCloseWarningPopup}>
            {text.common.ok}
          </PrimaryButton>
        </ConfirmBlock>
      </ModalPopup>
    </>
  );
};

const ConfirmBlock = styled.div`
  text-align: center;
`;

const SkillTableBlock = styled.div`
  background-color: ${COLORS.PRIMARY_WHITE};
  margin-bottom: 25px;
  width: calc(100vw - 245px);
  margin-top: 20px;
  .choose-proficiency-level {
    display: flex;
    align-items: center;
    gap: 10px;
    margin-bottom: 25px;
    h5 {
      padding: 0px !important;
    }
    .select-box {
      .MuiAutocomplete-root {
        width: 150px !important;
        .MuiFormControl-root {
          border-radius: 6px;
          border: 0.7px solid #a6b8d8;
          .MuiAutocomplete-inputRoot {
            padding: 2px !important;
            .MuiOutlinedInput-input {
              color: unset;
            }
          }
        }
      }
    }
  }
  &:last-child {
    margin-bottom: 0px;
  }
  .MuiBox-root {
    padding: 0px;
  }
  table {
    padding: 0px 10px;
  }
  .top-table .MuiTableCell-body {
    vertical-align: top;
  }
  .top-table{
    .proficiency-status{
      display: flex;
      justify-content: center;
      align-items: center;
      height: 300px;
    }
  }
  .MuiInputBase-root {
    margin: 0;
  }
  .MuiFormControl-root {
    padding-top: 0;
  }
  .MuiSelect-selectMenu {
    padding: 13px 26px 14px 12px;
  }
  .btn-block {
    display: flex;
    flex-direction: column;
    align-items: center;
    padding-top: 20px;
  }
  .gen-ai-source{
    align-items: flex-start;
  }
  .content-message {
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    height: 300px;
    > img {
      padding-bottom: 15px;
    }
    h4 {
      width: fit-content;
      padding: 0px 0px 4px;
    }
    p {
      font-size: 14px;
      padding: 0px 0px;
      width: 396px;
      text-align: center;
    } 
  }
  .control-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
  }
  .content-table {
    .loader {
      position: fixed;
      top: 40%;
    }
  }
  .relevancy-btn {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 10px;
    min-height: 10px;
  }
  .more_action {
    border: 1px solid #b0b4d0;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 5px;
    min-height: 10px;
    padding: 2px 10px;
    &:hover {
      cursor: pointer;
      background-color: #f0f3f8;
      border: 1px solid #b0b4d0;
    }
  }
  .more-option-container {
    display: flex;
    align-items: center;
    justify-content: flex-end;
    margin-bottom: 12px;
  }
`;

const Backdrop = styled.div`
  position: fixed;
  width: 100%;
  height: 100%;
  background-color: rgba(255, 255, 255, 0.6);
  z-index: 9999999;
  top: 0px;
  left: 0px;
  display: flex;
  align-items: center;
  justify-content: center;
`;